var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6613_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5202 2.82603H10.8901V1.60422C10.8901 0.718167 10.2443 0 9.4512 0H6.5488C5.75575 0 5.10986 0.718167 5.10986 1.60422V2.82603H1.47982C0.662238 2.82603 0 3.56286 0 4.47689V6.26764C0 6.65004 0.277977 6.9485 0.613183 6.9485H15.3868C15.722 6.9485 16 6.64071 16 6.26764V4.47689C16 3.56286 15.3378 2.82603 14.5202 2.82603ZM9.63924 2.82603H6.36076V1.60422C6.36076 1.4923 6.44251 1.39903 6.54062 1.39903H9.4512C9.54931 1.39903 9.63924 1.4923 9.63924 1.60422V2.82603Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07031 8.19824C1.38917 12.7964 1.69985 17.3945 2.0187 21.9926C2.0187 22.5523 2.38661 23.0093 2.83628 23.0093H7.40654H8.71467H13.2849C13.7346 23.0093 14.1025 22.5523 14.1025 21.9926C14.4214 17.3945 14.732 12.7964 15.0509 8.19824C12.7208 8.20757 10.3907 8.2169 8.06878 8.22622C5.73051 8.2169 3.40041 8.20757 1.07031 8.19824ZM4.91293 21.0133C4.89658 21.0133 4.88023 21.0133 4.86387 21.0133C4.54502 21.0133 4.27522 20.7335 4.25069 20.3698L3.62116 10.9497C3.59663 10.5673 3.85008 10.2315 4.18528 10.2035C4.52049 10.1849 4.81482 10.4647 4.83935 10.8471L5.46888 20.2672C5.50159 20.6403 5.24814 20.976 4.91293 21.0133ZM11.4127 10.8377C11.4372 10.4553 11.7479 10.1755 12.0667 10.1942C12.4019 10.2222 12.6554 10.5579 12.6309 10.9403L12.0013 20.3604C11.9768 20.7242 11.707 21.004 11.3881 21.004C11.3718 21.004 11.3554 21.004 11.3391 21.004C11.0039 20.976 10.7504 20.6403 10.775 20.2579L11.4127 10.8377ZM8.67379 10.875V20.3231C8.67379 20.7055 8.39581 21.0227 8.0606 21.0227C7.7254 21.0227 7.44742 20.7055 7.44742 20.3231V10.875C7.44742 10.4926 7.7254 10.1755 8.0606 10.1755C8.39581 10.1755 8.67379 10.4926 8.67379 10.875Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6613_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.a3ae5cd17695a10bbade572fb85ea94c.svg";
export { ForwardRef as ReactComponent };